import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) {
  return _pushScopeId("data-v-b7001d58"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "adaptive-box"
};
import { onBeforeUnmount, onMounted, ref } from 'vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'YkAdaptiveBox',
  props: {
    reference: {
      default: undefined
    },
    minWidth: {
      default: -Infinity
    },
    maxWidth: {
      default: Infinity
    },
    updateWidth: {
      type: Boolean,
      default: false
    },
    observeNodeUpdate: {
      type: Boolean,
      default: false
    },
    mode: {
      default: 'equal-width'
    }
  },
  setup: function (__props, _a) {
    var expose = _a.expose;
    var props = __props;
    onMounted(function () {
      initReference();
      resize();
      props.observeNodeUpdate && observeNode();
      window.addEventListener('resize', resize);
    });
    onBeforeUnmount(function () {
      window.removeEventListener('resize', resize);
      observer && observer.disconnect();
    });
    // 参考对象
    var reference = null;
    var adaptiveBoxRef = ref();
    var adaptiveContentRef = ref();
    // region TODO 初始化
    // 初始化参考对象
    function initReference() {
      if (props.reference) {
        reference = props.reference;
      } else {
        reference = window;
      }
      resizeHandel = resizeType[props.mode];
    }
    // endregion
    // region TODO 计算比例大小
    var resizeType = {
      'equal-width': resizeIsEqualWidth,
      contain: resizeIsContain,
      'full-height': resizeIsFullHeight
    };
    var resizeHandel = null;
    // 重置大小
    function resize() {
      resizeHandel && resizeHandel();
    }
    /**
     * 绘制与参考对象等宽
     */
    function resizeIsEqualWidth() {
      // 参考宽度
      var referenceWidth = reference.offsetWidth || reference.innerWidth;
      console.log(referenceWidth, reference);
      var $content = adaptiveContentRef.value;
      var scale = referenceWidth / $content.offsetWidth;
      var width = $content.offsetWidth * scale;
      if (props.minWidth && width < props.minWidth) {
        scale = props.minWidth / $content.scrollWidth;
        width = props.minWidth;
      }
      if (props.maxWidth && width > props.maxWidth) {
        scale = props.maxWidth / $content.scrollWidth;
        width = props.maxWidth;
      }
      $content.style.transform = "scale(".concat(scale, ")");
      // 计算缩放后所占的高度
      var height = $content.offsetHeight * scale;
      adaptiveBoxRef.value.style.height = "".concat(height, "px");
      if (props.updateWidth) {
        adaptiveBoxRef.value.style.width = "".concat(width, "px");
      }
    }
    /**
     * 绘制内容完全存在与参考对象中，左右居中
     */
    function resizeIsContain() {
      // 参考宽高
      var referenceWidth, referenceHeight;
      if (window === reference) {
        referenceWidth = reference.innerWidth;
        referenceHeight = reference.innerHeight;
      } else {
        referenceWidth = reference.offsetWidth;
        referenceHeight = reference.offsetHeight;
      }
      var $content = adaptiveContentRef.value;
      var scale = referenceWidth / $content.offsetWidth;
      var height = $content.offsetHeight * scale;
      var width = $content.offsetWidth * scale;
      if (height > referenceHeight) {
        scale = referenceHeight / $content.offsetHeight;
        height = $content.offsetHeight * scale;
        width = $content.offsetWidth * scale;
      }
      $content.style.transform = "scale(".concat(scale, ")");
      adaptiveBoxRef.value.style.height = "".concat(height, "px");
      adaptiveBoxRef.value.style.width = "".concat(width, "px");
    }
    /**
     * 绘制与参考对象等宽，并释放与参考对象同等高度的空间
     */
    var fullHeight = ref('');
    function resizeIsFullHeight() {
      // 参考宽高
      var referenceWidth, referenceHeight;
      if (window === reference) {
        referenceWidth = reference.innerWidth;
        referenceHeight = reference.innerHeight;
      } else {
        referenceWidth = reference.offsetWidth;
        referenceHeight = reference.offsetHeight;
      }
      var $content = adaptiveContentRef.value;
      var scale = referenceWidth / $content.offsetWidth;
      var width = $content.offsetWidth * scale;
      if (props.minWidth && width < props.minWidth) {
        scale = props.minWidth / $content.scrollWidth;
        width = props.minWidth;
      }
      if (props.maxWidth && width > props.maxWidth) {
        scale = props.maxWidth / $content.scrollWidth;
        width = props.maxWidth;
      }
      $content.style.transform = "scale(".concat(scale, ")");
      // 计算缩放后所占的高度
      var height = referenceHeight / scale;
      adaptiveBoxRef.value.style.height = "".concat(referenceHeight, "px");
      adaptiveContentRef.value.style.minHeight = fullHeight.value = "".concat(height, "px");
      if (props.updateWidth) {
        adaptiveBoxRef.value.style.width = "".concat(width, "px");
      }
    }
    // endregion
    // region TODO 观察节点变化
    var observer = null;
    // 开启监听节点变化
    function observeNode() {
      var config = {
        attributes: true,
        childList: true,
        subtree: true
      };
      observer = new MutationObserver(resize);
      observer.observe(adaptiveBoxRef.value, config);
    }
    // endregion
    expose({
      resize: resize
    });
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
        ref_key: "adaptiveBoxRef",
        ref: adaptiveBoxRef,
        class: "adaptive-box_body"
      }, [_createElementVNode("div", {
        ref_key: "adaptiveContentRef",
        ref: adaptiveContentRef,
        class: "adaptive-box_content",
        style: _normalizeStyle({
          '--adaptive-height': fullHeight.value
        })
      }, [_renderSlot(_ctx.$slots, "default")], 4)], 512)]);
    };
  }
});